(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["venz-graffiti-drop"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(){
document.querySelectorAll('[data-vg-clock]').forEach(function(el){
if(el.dataset.ready)return;el.dataset.ready='1';
if(el.dataset.demo==='true')return;
var end=Date.parse(el.dataset.deadline);if(!Number.isFinite(end))return;
function tick(){if(!el.isConnected){clearInterval(timer);return;}var s=Math.max(0,Math.floor((end-Date.now())/1000));if(!s){el.textContent='DROP CLOSED';clearInterval(timer);return;}var d=Math.floor(s/86400),h=Math.floor(s%86400/3600),m=Math.floor(s%3600/60);el.textContent=String(d).padStart(2,'0')+'D : '+String(h).padStart(2,'0')+'H : '+String(m).padStart(2,'0')+'M : '+String(s%60).padStart(2,'0')+'S';}
var timer=setInterval(tick,1000);tick();
});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
